/** @format */

import {OrderBasicDetails} from 'frontier-components';
import {Table} from '@sttark/design-system';
import DateOnly from '../../../../utilities/format/date';
import NumberFormat from 'react-number-format';
import React from 'react';

// styles
import './order_details.scss';

export const OrderDetails = props => {
    const {order} = props;

    return (
        <Table
            columns={[
                {
                    index: 'type',
                    title: 'Type',
                    key: 'type'
                },
                {
                    index: 'quantity',
                    title: 'Quantity',
                    key: 'quantity'
                },
                {
                    index: 'designs',
                    title: 'Designs',
                    key: 'designs'
                },
                {
                    index: 'date',
                    title: 'Date',
                    key: 'date'
                },
                {
                    index: 'status',
                    title: 'Status',
                    key: 'status'
                },
                {
                    index: 'itemized_description',
                    title: 'Itemized Description',
                    key: 'itemized_description'
                }
            ]}
            rows={[
                {
                    quantity: (
                        <NumberFormat
                            value={order.duplex_aware_total_qty}
                            thousandSeparator
                            displayType="text"
                        />
                    ),
                    itemized_description: (
                        <OrderBasicDetails
                            className="order-details-12pl__basic-details"
                            order={order}
                        />
                    ),
                    date: <DateOnly>{order.created}</DateOnly>,
                    designs: order.duplex_aware_design_qty,
                    type: order.product_type_label,
                    key: '1',
                    status: (
                        <span>
                            <i className={'fa ' + order.status_icon} />{' '}
                            {order.external_status_label}
                        </span>
                    )
                }
            ]}
        />
    );
};
